import React from 'react';

export const FullScreenLayout = (props) => (
  <div className='grid-x full-height'>
    <div className='cell medium-12 large-12 light-background'>
      {props.children}
    </div>
  </div>
);
